import {styled, Tab, TextField} from "@mui/material";

export const StyledTab = styled(Tab)({
    "&.Mui-selected": {
        color: "white"
    },
    color: '#B2DFDB',
    fontWeight: 'bold'
});

export const UnStyledTextField = styled(TextField, {
    shouldForwardProp: (prop) => prop !== 'isReadOnly',
})(({ isReadOnly }) => ({
    width: "50%",
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
        borderBottom: isReadOnly ? 'none' : undefined,
    },
    '& .MuiInputBase-input': {
        cursor: isReadOnly ? 'default' : 'text',
    },
    // Also remove focus effect if desired
    '& .MuiInput-underline:after': {
        borderBottom: isReadOnly ? 'none' : undefined,
    }
}));